import { z } from 'zod';
import { PeerGroupCreateFormValueSchema } from '../../group/create';

export const PeerMemberEditFormValueSchema = PeerGroupCreateFormValueSchema;

export const PeerMemberEditPathParamsSchema = z.object({
    competitiveSetId: z.string(),
});
